import * as types from '../types'
import store from 'store2'
let account = {
  state: {
    menus: JSON.parse(store('menus') || '[]'),
    power: JSON.parse(store('power') || '[]'),
    accessToken: store('accessToken') || '',
    refreshToken: store('refreshToken') || '',
    tokenType: store('tokenType') || '',
    userInfo: JSON.parse(store('userInfo') || '{}')
  },
  mutations: {
    [types.KEEP_TOKEN_INFO] (state, { access_token, refresh_token, token_type }) {
      state.accessToken = access_token
      state.refreshToken = refresh_token
      state.tokenType = token_type
      store({
        accessToken: access_token,
        refreshToken: refresh_token,
        tokenType: token_type
      })
    },
    [types.KEEP_POWER] (state, { menus, resources }) {
      state.menus = menus
      state.power = resources
      store({
        'menus': JSON.stringify(menus),
        'power': JSON.stringify(resources)
      })
    },
    [types.KEEP_USER_INFO] (state, payload) {
      state.userInfo = payload
    },
    [types.LOGOUT] (state) {
      state.menus = []
      state.power = []
      state.accessToken = ''
      state.refreshToken = ''
      state.tokenType = ''
      store.clearAll()
    }
  },
  actions: {
    saveToken ({ commit }, payload) {
      commit('KEEP_TOKEN_INFO', payload)
    },
    savePower ({ commit }, payload) {
      commit('KEEP_POWER', payload)
    },
    saveUserInfo ({ commit }, payload) {
      store('userInfo', JSON.stringify(payload))
      commit('KEEP_USER_INFO', payload)
    },
    logout ({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    accessToken: (state) => state.accessToken,
    refreshToken: (state) => state.refreshToken,
    tokenType: (state) => state.tokenType,
    userInfo: (state) => state.userInfo,
    power: (state) => state.power
  }
}

export default account



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/modules/account.ts